<template>
    <div class="traceability-contract-view-page">
        <base-header
            :titulo="translate('traceabilityReport.title')"
            :btn-texto="translate('traceabilityReport.individual_record')"
            :exibeBotao='true'
            icon='el-icon-document-add'
            @btnHeaderClicado='newRecord()'
        />
        <div class="view-container-wrapper">
            <div class="content">
                <filters @changeFilters="changeFilters" />
                <totalizers />
                <export-list-table :filters="filters" />
            </div>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            filters: {}
        };
    },
    components: {
        BaseHeader: () => import('@/components/BaseHeader'),
        Filters: () => import('@/modules/traceability-report/views/pages/view-exports/components/filters/index.vue'),
        Totalizers: () => import('@/modules/traceability-report/views/pages/view-exports/components/totalizers/index.vue'),
        ExportListTable: () => import('@/modules/traceability-report/views/pages/view-exports/components/report-list/index.vue')
    },
    methods: {
        translate(key, params = {}) {
            const base = 'relatorio_rastreabilidade.messages';
            return this.$t(`${base}.${key}`, params);
        },
        newRecord() {
            this.$router.push({ name: 'RelatorioRastreabilidadeCadastro' });
        },
        changeFilters(filters) {
            this.filters = filters;
        }
    }
};
</script>
<style scoped lang="scss">
.traceability-contract-view-page {
    .view-container-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
    }
}
</style>
